let initialFields = {
  underweight: 'No',
  wasted: 'No',
  stunted: 'No',
  bsa: '',
  smrStage: '',
};

export default initialFields;
